import React from 'react';

const styleList = [
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fba56b6a0cbc404b1.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fa55797bc4d565c5c.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F3e1d7107c7560fce.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fc4f78921165da2fd.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe16f309a9936eb4a.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F3aa9db03bea36014.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F683a29cd6e3b7039.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F25a2ec68d3008468.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F05900d83e2a29a18.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F12998be7c1f3975e.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe29011cb00de1ff0.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F841b241d55d06a9b.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F7b55e6e0c90410e2.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fff91f2509a9a892e.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F4f53bea055403e96.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F8da9319f82cb4238.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F7aa4c3c4c4b05877.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F5cc17a670dfe797e.webp?alt=media",
    title: ""
  },
  {
    before: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fc6dda6cc32003a9e.webp?alt=media",
    after: "https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F963d4d4ccd25d044.webp?alt=media",
    title: ""
  },
]
const BeforeAfterTestimonial = ({ images }) => {
  return (
    <div className="relative">
      <div className="slider-in group relative grid slider-in-motions">
        <div className="relative mx-auto grid h-full w-full max-w-[2200px] py-1.5 grid-cols-2">
          <div className="relative col-span-1 overflow-hidden">
            <div className="space-y-8 md:space-y-[85px]">
              <div className="relative mx-auto max-w-[2200px] overflow-hidden">
                <div className="infinite-scroll-16 -mt-4 flex max-h-[780px] min-w-[5100px] overflow-hidden lg:min-w-[5100px]">
                  <div className="slider-running-wrapper">
                    {styleList.map((c, i) => {
                      return (
                        <div className="relative" key={i}>
                          <article className="rnftg-item rnftg-rounded-2xl dark:rnftg-bg-gray-800 rnftg-transition rnftg-duration-300">
                            <div className="rnftg-item__img-wrapper_landing">
                              <div className="result-box">
                                <img
                                  className="banner-video"
                                  loading="eager" decoding="async"
                                  alt="reok"
                                  src={c.before}
                                ></img>
                              </div>
                            </div>
                          </article>
                        </div>
                      )
                    })}
                  </div>
                  <div className="slider-running-wrapper">
                    {styleList.map((c, i) => {
                      return (
                        <div className="relative" key={i}>
                          <article className="rnftg-item rnftg-rounded-2xl dark:rnftg-bg-gray-800 rnftg-transition rnftg-duration-300">
                            <div className="rnftg-item__img-wrapper_landing">
                              <div className="result-box">
                                <img
                                  className="banner-video"
                                  loading="eager" decoding="async"
                                  alt="reok"
                                  src={c.before}
                                ></img>
                              </div>
                            </div>
                          </article>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="absolute left-1/2 top-0 z-10 h-full w-3 -translate-x-1/2 rounded-sd border-2 transition-opacity md:w-3.5"
            style={{
              borderRadius: "10px",
              background: "#fff",
              borderWidth: "2px",
              border: "2px solid #c7f8ff"
            }}
          />
          <div className="relative col-span-1 overflow-hidden">
            <div className="space-y-8 md:space-y-[85px]">
              <div className="relative mx-auto max-w-[2200px] overflow-hidden">
                <div className="slider-in-right infinite-scroll-16 -mt-4 flex max-h-[780px] min-w-[5100px] overflow-hidden lg:min-w-[5100px]">
                  <div className="slider-running-wrapper-right">
                    {styleList.map((c, i) => {
                      return (
                        <div className="relative" key={i}>
                          <article className="rnftg-item rnftg-rounded-2xl dark:rnftg-bg-gray-800 rnftg-transition rnftg-duration-300">
                            <div className="rnftg-item__img-wrapper_landing">
                              <div className="result-box">
                                <img
                                  className="banner-video"
                                  loading="eager" decoding="async"
                                  alt="reok"
                                  src={c.after}
                                ></img>
                              </div>
                            </div>
                          </article>
                        </div>
                      )
                    })}
                  </div>
                  <div className="slider-running-wrapper-right">
                    {styleList.map((c, i) => {
                      return (
                        <div className="relative" key={i}>
                          <article className="rnftg-item rnftg-rounded-2xl dark:rnftg-bg-gray-800 rnftg-transition rnftg-duration-300">
                            <div className="rnftg-item__img-wrapper_landing">
                              <div className="result-box">
                                <img
                                  className="banner-video"
                                  loading="eager" decoding="async"
                                  alt="reok"
                                  src={c.after}
                                ></img>
                              </div>
                            </div>
                          </article>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterTestimonial;
